// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1t0UT","field":"styles_field__3_mP-","fieldCol":"styles_fieldCol__3Pu3Y","diffCol":"styles_diffCol__2bSV_","diff":"styles_diff__PvBsJ"};